
import { lazy } from "react";
import GuestLayout from "@/layouts/GuestLayout";
import { createRoutesConfig } from "@/utils/routeUtils";

// Lazy load guest pages
const GuestDashboardPage = lazy(() => import("@/pages/guest/GuestDashboardPage"));
const GuestBookingsPage = lazy(() => import("@/pages/guest/GuestBookingsPage"));
const GuestWishlistsPage = lazy(() => import("@/pages/guest/GuestWishlistsPage"));
const GuestMessagesPage = lazy(() => import("@/pages/guest/GuestMessagesPage"));
const GuestSettingsPage = lazy(() => import("@/pages/guest/GuestSettingsPage"));
const GuestPreferencesPage = lazy(() => import("@/pages/guest/GuestPreferencesPage"));
const GuestReviewsPage = lazy(() => import("@/pages/guest/GuestReviewsPage"));

// Create base guest routes configuration
const guestRoutesConfig = createRoutesConfig("/guest", <GuestLayout />, "guest");

// Define guest routes
export const guestRoutes = {
  ...guestRoutesConfig,
  children: [
    { path: "", element: <GuestDashboardPage /> },
    { path: "bookings", element: <GuestBookingsPage /> },
    { path: "wishlists", element: <GuestWishlistsPage /> },
    { path: "messages", element: <GuestMessagesPage /> },
    { path: "settings", element: <GuestSettingsPage /> },
    { path: "preferences", element: <GuestPreferencesPage /> },
    { path: "reviews", element: <GuestReviewsPage /> },
  ],
};
